import { render } from "./xxzbyc.vue?vue&type=template&id=71444c24&scoped=true&ts=true"
import script from "./xxzbyc.vue?vue&type=script&lang=ts"
export * from "./xxzbyc.vue?vue&type=script&lang=ts"

import "./xxzbyc.vue?vue&type=style&index=0&id=71444c24&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71444c24"]])

export default __exports__